<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col>
        <h3>Raport dotyczący zajęć przeprowadzonych przez lektora</h3>
        <b-row>
          <b-col>
            <b-form-group label="Od" class="required">
              <date-picker
                v-model="startDate"
                :config="calendarOptions"
                language="pl"
                autocomplete="off"
                :class="{'is-invalid': $v.startDate.$error}"
              ></date-picker>
              <b-form-invalid-feedback v-if="!$v.startDate.required">To pole jest wymagane</b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="Do" class="required">
              <date-picker
                v-model="endDate"
                :config="calendarOptions"
                language="pl"
                autocomplete="off"
                :class="{'is-invalid': $v.endDate.$error}"
              ></date-picker>
              <b-form-invalid-feedback>
                <div :force-show="!$v.endDate.isEndAfterStart">Data od musi poprzedzać datę do</div>
                <div v-if="!$v.endDate.required">To pole jest wymagane</div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group class="required" label="Lektor">
              <b-form-select
                v-model="selectedLector"
                :options="lectors"
                :state="$v.selectedLector.$error? false : null"
                @input="$v.selectedLector.$reset()"
              ></b-form-select>
              <b-form-invalid-feedback>
                <div v-if="!$v.selectedLector.required">To pole jest wymagane</div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group label="Komentarz dla lektora">
          <b-form-textarea v-model="comment" rows="4"></b-form-textarea>
        </b-form-group>

        <b-row align-h="center">
          <b-col>
            <b-button-toolbar class="float-right">
              <b-button
                class="mx-1"
                type="submit"
                variant="primary"
                :disabled="loading"
                @click.prevent="onPreview"
              >
                <span v-show="!loading">
                  <font-awesome-icon icon="file-pdf"></font-awesome-icon>&nbsp;Podgląd
                </span>
                <span v-show="loading">
                  <b-spinner small label="Loading..."></b-spinner>
                </span>
              </b-button>

              <b-button
                type="submit"
                variant="primary"
                :disabled="loading"
                @click.prevent="onDownload"
              >
                <span v-show="!loading">
                  <font-awesome-icon icon="file-download"></font-awesome-icon>&nbsp;Pobierz
                </span>
                <span v-show="loading">
                  <b-spinner small label="Loading..."></b-spinner>
                </span>
              </b-button>
            </b-button-toolbar>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="scss" scoped>
</style>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required, helpers } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  data() {
    return {
      loading: true,

      startDate: "",
      endDate: "",
      comment: "",
      selectedLector: null,
      lectors: [{ value: null, text: "" }],
      calendarOptions: {
        format: "YYYY-MM-DD",
        locale: "pl",
        useCurrent: true
      }
    };
  },
  validations: {
    selectedLector: {
      required
    },
    endDate: {
      isEndAfterStart: function() {
        return (
          !helpers.req(this.endDate) ||
          moment(this.endDate).isSameOrAfter(this.startDate)
        );
      },
      required
    },
    startDate: {
      required
    }
  },
  mounted() {
    axios
      .get("lectors/list")
      .then(result => {
        result.data.forEach(element => {
          this.lectors.push({
            value: element.id,
            text: element.firstName + " " + element.lastName
          });
        });
      })
      .catch(err => {
        eventBus.$emit("unhandled-error", err);
        return null;
      })
      .then(() => (this.loading = false));
  },
  methods: {
    onPreview() {
      this.onSubmit(false);
    },
    onDownload() {
      this.onSubmit(true);
    },
    onSubmit(download) {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.loading = true;

        axios({
          method: "post",
          url: "/reports/pdf/lector",
          responseType: "blob",
          data: {
            userId: this.selectedLector,
            from: this.startDate,
            to: this.endDate,
            comment: this.comment
          }
        })
          .then(function(response) {
            let link = document.createElement('a');
            link.setAttribute("type", "hidden");
            link.href = window.URL.createObjectURL(response.data);
            if (download) {
              link.download = "Report.pdf";
              document.body.appendChild(link);
              link.click();
            } else {
              window.open(link);
            }
            link.remove();
          })
          .catch(err => {
            eventBus.$emit("unhandled-error", err);
          })
          .then(() => (this.loading = false));
      }
    }
  }
};
</script>
